import React, { useMemo } from 'react';
import moment from 'moment';
import { useQuery } from 'react-query';
import { createQuery } from '@store/overviewDashboard/kpiData/helper';
import { ALL_TRAFFIC } from '@utils/filter';
import { SPI_METRIC } from '@components/top-widget-panel/spi-panel/widgets/constants';
import getMetricsData from '@api/metricContainer';
import { get } from 'lodash';
import { getTextColor } from '@components/overview-dashboard/metrics-container/spi-widget/SPIMetricsText';
import instance from '@api/axiosInstance';
import { DATE_TIME_FORMAT } from '@utils/constants';

// 6 hour window, rounded off to 15m
function calculateInterval() {
  const to = moment();
  const interval = Math.floor(to.minute() / 15);
  to.minute(15 * interval)
    .seconds(0)
    .format();
  const from = moment(to).subtract(6, 'hours');
  return [from, to];
}

// fetch spi score based on input thresholds
function useSPI({ threshold }) {
  const [from, to] = calculateInterval();
  const payload = createQuery(
    [SPI_METRIC],
    `${from.format()}/${to.format()}`,
    ALL_TRAFFIC.rule,
    'ALL',
    threshold,
  );
  // reload only when selectedThreshold changes
  // payload params are refreshed only when popup is closed and reopened
  const { data, isFetching, isIdle } = useQuery(
    ['getSPIScore', threshold],
    () => getMetricsData(payload, {}, instance),
    { retry: true, refetchOnWindowFocus: false, enabled: !!threshold },
  );
  const spiScore = get(data, ['data', 0, 'totals', SPI_METRIC]);
  const timeLabel = `${from.format(DATE_TIME_FORMAT)} to ${to.format(DATE_TIME_FORMAT)}`;
  return {
    spiScore,
    isFetching: isFetching || isIdle,
    spiColor: getTextColor(spiScore || 0),
    timeLabel,
  };
}

export default useSPI;
